import { render, staticRenderFns } from "./juridicalPersonData.vue?vue&type=template&id=d0d23ccc&scoped=true&"
import script from "./juridicalPersonData.vue?vue&type=script&lang=js&"
export * from "./juridicalPersonData.vue?vue&type=script&lang=js&"
import style0 from "./juridicalPersonData.vue?vue&type=style&index=0&id=d0d23ccc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d23ccc",
  null
  
)

export default component.exports